"use strict"

import React, { useEffect, useState } from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { addNewObject, updateObject } from "../../Loaders"

import { logToServer } from "../../ErrorBoundary"
import AddDCSTableModal from "./modals/AddDCSTableModal"
import SetHeightLoaderFrame from "../widgets/SetHeightLoaderFrame"
import { displayRef } from "../widgets/utils"
import { showModal, hideModal } from "../../shared_components/utils"
import { Button, ButtonGroup } from "react-bootstrap"
import EditDCSTagsModal from "./modals/EditDCSTagsModal"
import { withSourceRegistrationConfig } from "../../config/SourceRegistrationConfigProvider"
import { LanzaTable } from "../../shared_components/widgets/LanzaTable"
import EditDCSTablesModal from "./modals/EditDCSTablesModal"
import AreYouSureModal from "../widgets/AreYouSureModal"
import { UnregisterDCSTable } from "./modals/ModalParts"

function _ManageDCSTables(props) {
  const [tables, setTables] = useState([])
  const [tableFocus, setTableFocus] = useState({})
  const [allPseudoTables, setAllPseudoTables] = useState(false)

  useEffect(() => {
    const source_tables = props.dcs_tables.filter((table) => table.source.name === props.source.name)
    const pseudo_tables = source_tables.filter((table) => table.pseudo_table)
    setAllPseudoTables(pseudo_tables.length === source_tables.length)
    setTables(source_tables)
    if (!tableFocus.name && source_tables.length > 0) {
      setTableFocus(source_tables[0])
    } else if (source_tables.filter((tbl) => tbl.name === tableFocus.name).length > 0) {
      setTableFocus(source_tables.filter((tbl) => tbl.name === tableFocus.name)[0])
    }
  }, [props.dcs_tables])

  const [newTableModal, setNewTableModal] = useState(false)
  const [newTableWarn, setNewTableWarn] = useState(false)

  const [editDCSTagsModal, setEditDCSTagsModal] = useState(false)
  const [editDCSTagsWarn, setEditDCSTagsWarn] = useState(false)

  const [editDCSTablesModal, setEditDCSTablesModal] = useState(false)
  const [editDCSTablesWarn, setEditDCSTablesWarn] = useState(false)

  const [deleteDCSTablesModal, setDeleteDCSTablesModal] = useState(false)
  const [deleteDCSTablesWarn, setDeleteDCSTablesWarn] = useState(false)

  const intl = useIntl()

  const generateNewTable = (data, loaderRef) => {
    addNewObject("/warehouse/dcs_tables/", data)
      .then((_) => {
        setNewTableModal(false)
        setNewTableWarn(false)
        props.getTablesLoad(props.type)
      })
      .catch((err) => {
        displayRef(loaderRef, false)
        console.error(err)
        logToServer(err)
        setNewTableWarn(err)
      })
  }

  const editDCSTags = (data, loaderRef, table_id) => {
    const info = {
      data: data,
      table_id: table_id,
    }

    updateObject("/warehouse/dcs_tags/bulk_update/", info)
      .then((_) => {
        setEditDCSTagsModal(false)
        setEditDCSTagsWarn(false)
        props.getTablesLoad(props.type)
      })
      .catch((err) => {
        displayRef(loaderRef, false)
        console.error(err)
        logToServer(err)
        setEditDCSTagsWarn(err)
      })
  }

  const editDCSTable = (data, loaderRef) => {
    updateObject("/warehouse/dcs_tables/bulk_update/", data)
      .then((_) => {
        setEditDCSTablesModal(false)
        setEditDCSTablesWarn(false)
        props.getTablesLoad(props.type)
      })
      .catch((err) => {
        displayRef(loaderRef, false)
        console.error(err)
        logToServer(err)
        setEditDCSTablesWarn(err)
      })
  }

  const cancelDeleteForm = (e) => {
    if (e) {
      e.preventDefault()
    }

    setDeleteDCSTablesModal(false)
  }

  const submitDeleteForm = (e, data) => {
    if (e) {
      e.preventDefault()
    }

    updateObject(`/warehouse/dcs_tables/${data.id}/unregister_table/`, data)
      .then((_) => {
        setDeleteDCSTablesModal(false)
        setDeleteDCSTablesWarn(false)
        props.getTablesLoad(props.type)
      })
      .catch((err) => {
        console.error(err)
        logToServer(err)
        setDeleteDCSTablesModal(false)
        setDeleteDCSTablesWarn(err)
      })
  }

  const table_columns = [
    {
      Header: <FormattedMessage id="reactormanagement.dcstable" />,
      id: "name",
      className: "text-center",
      accessor: (table) => {
        return <p>{table["name"]}</p>
      },
    },
    !allPseudoTables && {
      Header: <FormattedMessage id="reactormanagement.numunregisteredcolumns" />,
      id: "unregistered_cols_num",
      className: "text-center",
      disableFilters: true,
      accessor: (table) => {
        return (
          <div
            className={table["unregistered_cols_num"] > 0 && table.active ? "table_warning" : "table_okay"}
          >
            <p>{table["unregistered_cols_num"]}</p>
          </div>
        )
      },
    },
    !allPseudoTables && {
      Header: <FormattedMessage id="general.active" />,
      id: "active",
      className: "text-center",
      disableFilters: true,
      disableSortBy: true,
      accessor: (table) => {
        if (table["active"]) {
          return (
            <h5>
              <span className="fa fa-check-circle-o text-success" />
            </h5>
          )
        } else {
          return (
            <h5>
              <span className="fa fa-times-circle text-danger" />
            </h5>
          )
        }
      },
    },
    !allPseudoTables && {
      Header: <FormattedMessage id="sourceregistration.timestamp.column.valid" />,
      id: "valid_timestamp_column",
      className: "text-center",
      disableFilters: true,
      disableSortBy: true,
      accessor: (table) => {
        if (table["valid_timestamp_column"]) {
          return (
            <h5>
              <span className="fa fa-check-circle-o text-success" />
            </h5>
          )
        } else {
          return (
            <div className={table.active ? "table_warning" : "table_okay"}>
              <h5>
                <span className="fa fa-times-circle text-danger" />
              </h5>
            </div>
          )
        }
      },
    },
    !allPseudoTables && {
      Header: <FormattedMessage id="general.status" />,
      id: "status",
      className: "text-center",
      disableSortBy: true,
      disableFilters: true,
      accessor: (table) => {
        if (table["status"] === "Inspecting") {
          return (
            <h5>
              <span className="fa fa-refresh text-info" />
            </h5>
          )
        } else if (table["status"] === "Error") {
          return (
            <h5 className={"table_warning"}>
              <span className="fa fa-times-circle text-danger" />
            </h5>
          )
        } else if (table["status"] === "Deleting") {
          return (
            <h5>
              <span className="fa fa-trash-o text-danger" />
            </h5>
          )
        } else {
          return (
            <h5>
              <span className="fa fa-check-circle-o text-success" />
            </h5>
          )
        }
      },
    },
    {
      Header: <FormattedMessage id={"reactormanagement.managedcstags"} />,
      id: "dcstags",
      className: "text-center",
      disableSortBy: true,
      disableFilters: true,
      accessor: (table) => {
        return (
          <ButtonGroup>
            <Button
              variant={"outline-primary"}
              size={"sm"}
              onClick={(e) => {
                e.preventDefault()
                setTableFocus(table)
                showModal(setEditDCSTagsModal)
              }}
              disabled={["Deleting", "Error"].includes(table["status"]) && !table.pseudo_table}
              title={intl.formatMessage({
                id: "sourceregistration.edit.source.tags",
              })}
            >
              <span className={"fa fa-align-justify"} />
            </Button>
          </ButtonGroup>
        )
      },
    },
    !allPseudoTables &&
      props.permissions.includes("change_dcstable") && {
        Header: <FormattedMessage id={"sourceregistration.unregister.table"} />,
        id: "unregister",
        className: "text-center",
        disableSortBy: true,
        disableFilters: true,
        accessor: (table) => {
          if (props.permissions.includes("change_dcstable")) {
            return (
              <Button
                variant={"outline-primary"}
                size={"sm"}
                disabled={!!(["Deleting", "Error"].includes(table["status"]) || table.pseudo_table)}
                onClick={(e) => {
                  e.preventDefault()
                  setTableFocus(table)
                  showModal(setDeleteDCSTablesModal)
                }}
              >
                <i className="fa fa-times text-danger" />
              </Button>
            )
          } else {
            return <span />
          }
        },
      },
  ]

  return (
    <React.Fragment>
      {newTableModal && (
        <AddDCSTableModal
          show={newTableModal}
          onHide={() => hideModal(setNewTableModal)}
          label={"New DCS Table"}
          page_glyph={"fa-check-square-o"}
          page_translation_id={"sourceregistration.register.new.dcs.table"}
          warning={newTableWarn}
          clearWarning={() => setNewTableWarn(false)}
          source={props.source}
          unwatched_tables={props.unwatched}
          uploadData={generateNewTable}
        />
      )}
      {editDCSTagsModal && (
        <EditDCSTagsModal
          show={editDCSTagsModal}
          onHide={() => setEditDCSTagsModal(false)}
          warning={editDCSTagsWarn}
          data_types={props.data_types}
          units={props.units}
          tags={props.source.tags}
          table={tableFocus}
          userCanEditTags={props.permissions.includes("change_dcstable")}
          submitData={editDCSTags}
        />
      )}
      {editDCSTablesModal && (
        <EditDCSTablesModal
          show={editDCSTablesModal}
          onHide={() => setEditDCSTablesModal(false)}
          warning={editDCSTablesWarn}
          source={props.source}
          tables={tables}
          submitData={editDCSTable}
        />
      )}
      {deleteDCSTablesModal && (
        <AreYouSureModal
          show={deleteDCSTablesModal}
          onHide={(e) => cancelDeleteForm(e)}
          data={tableFocus}
          modalBody={<UnregisterDCSTable title={"sourceregistration.unregister.table"} data={tableFocus} />}
          submitForm={submitDeleteForm}
          cancelForm={cancelDeleteForm}
        />
      )}
      <div style={{ marginTop: "40px" }}>
        <div className={"row"} style={{ marginBottom: "5px" }}>
          <div className={"col-8"}>
            <h5>
              <FormattedMessage id={"reactormanagement.managedcstables"} description={"Manage DCS Tables"} />:
            </h5>
          </div>
          <div className={"col-4"}>
            <ButtonGroup style={{ float: "right" }}>
              {props.permissions.includes("change_dcstable") && !allPseudoTables && (
                <Button
                  variant={"outline-primary"}
                  onClick={(e) => {
                    e.preventDefault()
                    showModal(setEditDCSTablesModal)
                  }}
                  title={intl.formatMessage({
                    id: "sourceregistration.edit.dcs.tables",
                  })}
                  disabled={tables.length <= 0 || allPseudoTables}
                >
                  <span className={"fa fa-pencil"} />
                </Button>
              )}
              {props.permissions.includes("add_dcstable") &&
                Object.keys(props.unwatched || {}).length > 0 && (
                  <Button
                    variant={"outline-primary"}
                    onClick={(e) => {
                      e.preventDefault()
                      showModal(setNewTableModal)
                    }}
                    title={intl.formatMessage({
                      id: "sourceregistration.register.new.dcs.table",
                    })}
                  >
                    <span className={"fa fa-plus-circle"} />
                  </Button>
                )}
            </ButtonGroup>
          </div>
        </div>
        <div>
          {props.dcsTablesLoading ? (
            <SetHeightLoaderFrame height={250} />
          ) : (
            <LanzaTable
              className="table table-bordered table-condensed table-hover tbl_lanzatable"
              columns={table_columns.filter((col) => col)} // Filter out conditional columns
              data={tables}
              allowSorting={true}
              allowFilters={false}
              initialTableOptions={{
                pageSize: 10,
              }}
            />
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

const ManageDCSTablesTable = withSourceRegistrationConfig(_ManageDCSTables)
export default ManageDCSTablesTable
